import { render, staticRenderFns } from "./Members.vue?vue&type=template&id=84f56ac8&scoped=true&"
import script from "./Members.vue?vue&type=script&lang=js&"
export * from "./Members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f56ac8",
  null
  
)

export default component.exports